import { ReactElement } from 'react';

import { HealthcareFacilityLocationSpecialty } from '@dreryk/egabinet-healthcare-provider-frontend-api';

import { BindingCreator } from '@dreryk/react-common';
import { Autosuggest, StyledFlex } from '@dreryk/react-components';

import { referralTranslationKeys } from '../../translations';

import {
   createHealthcareFacilityLocationSpecialtySearchCreator,
   itemRenderer,
   labelExtractor,
   validationRules,
} from './HealthcareFacilityLocationSpecialtyField.utils';
import {
   HealthcareFacilityLocationSpecialtyFormBeanPart,
   SpecialtyType,
} from './HealthcareFacilityLocationSpecialtyField.types';

type HealthcareFacilityLocationSpecialtyFieldProps = {
   readonly register: BindingCreator<HealthcareFacilityLocationSpecialtyFormBeanPart>;
   readonly specialtyType: SpecialtyType;
   readonly children?: ReactElement;
};

export const HealthcareFacilityLocationSpecialtyField = (
   props: HealthcareFacilityLocationSpecialtyFieldProps
): JSX.Element => {
   return (
      <StyledFlex direction={'column'}>
         <Autosuggest<HealthcareFacilityLocationSpecialty>
            placeholder={referralTranslationKeys.referralToHospital.insertHospitalWardType}
            label={referralTranslationKeys.referralToHospital.hospitalWard}
            minChars={3}
            labelExtractor={labelExtractor}
            itemRenderer={itemRenderer}
            searchCreator={createHealthcareFacilityLocationSpecialtySearchCreator(props.specialtyType)}
            keyProperty={(specialty) => specialty.code.toString()}
            controller={props.register('healthcareFacilityLocationSpecialty', validationRules)}
            testId={'healthcareFacilityLocationSpecialty'}
         />
         {props.children}
      </StyledFlex>
   );
};
